export class SearchReportQuery {
  searchReportQueryId: string;
  searchReportId: string;
  query: string;
  hitCount: number;
  expandedHitCount: number;
  uniqueHitCount: number;
  valid: boolean;
}

export class SearchReportQueryBatch {
  queries: SearchReportQuery[];
}
